import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../../icon.component';

export type CtaButtonKind = 'internal' | 'external';

@Component({
  selector: 'app-cta-block',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './cta-block.component.html',
  styleUrls: ['./cta-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaBlockComponent {
  @Input() eyebrow?: string;
  @Input({ required: true }) title!: string;
  @Input() text?: string;
  @Input({ required: true }) buttonLabel!: string;
  @Input({ required: true }) buttonUrl!: string;
  @Input() buttonKind?: CtaButtonKind;

  get kind(): CtaButtonKind {
    if (this.buttonKind) return this.buttonKind;
    return this.buttonUrl?.startsWith('/') ? 'internal' : 'external';
  }

  get routerLinkValue(): unknown[] {
    return [this.buttonUrl];
  }
}
